import { privateRoutes } from "@/routes/private.tsx";
import * as Sentry from "@sentry/react";
import { BrowserRouter, useRoutes } from "react-router-dom";

const useSentryRoutes = Sentry.wrapUseRoutes(useRoutes);

const Routes = () => {
	const routes = useSentryRoutes([...privateRoutes]);
	return routes;
};

export const AppRoutes = () => {
	return (
		<BrowserRouter>
			<Routes />
		</BrowserRouter>
	);
};
